import _ from 'underscore';
import Personalizer from 'personalizer';
import MapUtil from 'views/utils/LeafletMap/utils/MapUtil';
import NewSendToDeviceModal from '../standaloneComponents/SendToDevice/NewSendToDeviceModal';
import * as sendTypes from '../standaloneComponents/SendToDevice/SendToDeviceUtils';
import ReactComponentView from 'views/main/react/ReactComponentView';

var elevationGainThreshold = 2,
    elevationLossThreshold = 2,
    roundTripDirections = ['north', 'south', 'east', 'west'],
    CourseUtil = {
        getElevationGainThreshold: function() {
            return elevationGainThreshold;
        },

        getElevationLossThreshold: function() {
            return elevationLossThreshold;
        },

        convertElevationDataForElevationAnalyzer: function(point) {
            var analyzerPoint;

            if (point) {
                var distance = point.distance || point.x;
                if (_.isNaN(distance) || !_.isNumber(distance)) {
                    distance = 0;
                }

                analyzerPoint = {
                    elevation: Personalizer.convertElevationToMeter(point.y || point.elevation),
                    lat: point.latlng ? point.latlng[0] : point.lat,
                    lng: point.latlng ? point.latlng[1] : point.lng,
                    distance: distance > 0 ? Personalizer.revertDistance(distance) : distance
                };
            }

            return analyzerPoint;
        },

        getElevationDataFromGeoPoints: function(geoPoints, shouldStripDupDistancesFromPoints = true) {
            var elevationData = [],
                distance = 0,
                point,
                totalDistance = 0,
                previousPoint;

            for (var p = 0, pLen = geoPoints.length; p < pLen; p += 1) {
                if (geoPoints[p]) {
                    point = geoPoints[p];

                    if (previousPoint) {
                        if (point.distance !== null && point.distance !== undefined) {
                            distance = point.distance;
                        } else {
                            distance = this.calculateDistanceBetweenPointsInMeters(
                                previousPoint.latitude,
                                previousPoint.longitude,
                                point.latitude,
                                point.longitude
                            );
                            totalDistance += distance;
                            distance = totalDistance;
                        }
                    }

                    previousPoint = point;

                    if (point.latitude && point.longitude) {
                        elevationData.push({
                            latlng: [point.latitude, point.longitude],
                            timestamp: point.timestamp,
                            y: point.elevation ? Personalizer.convertElevation(point.elevation) : null,
                            x: Personalizer.convertDistance(distance)
                        });
                    }
                }
            }

            elevationData.sort(this.sortElevationDataByDistance);

            if (shouldStripDupDistancesFromPoints) {
                this.stripDupDistancesFromPoints(elevationData, 'x');
            }

            return elevationData;
        },

        calculateAvgGradient: function(startElevation, endElevation, distance) {
            //Note: all three units being passed in should be using the same measurement - ex: meters
            var avgGradient = (100 * (endElevation - startElevation)) / distance;
            return _.isNaN(avgGradient) || !_.isFinite(avgGradient) ? 0 : avgGradient;
        },

        calculateBoundingBoxAreaInKM: function(north, south, east, west) {
            return MapUtil.calculateBoundingBoxAreaInKM(north, south, east, west);
        },

        calculateDistanceBetweenPointsInKM: function(startLat, startLng, endLat, endLng) {
            return MapUtil.calculateDistanceBetweenPointsInKM(startLat, startLng, endLat, endLng);
        },

        calculateDistanceBetweenPointsInMeters: function(startLat, startLng, endLat, endLng) {
            return MapUtil.calculateDistanceBetweenPointsInMeters(startLat, startLng, endLat, endLng);
        },

        calculateDistanceFromLeafletLatLngs: function(latLngs) {
            return MapUtil.calculateDistanceFromCollectionOfLatLngs(latLngs);
        },

        /**
         * Assumption is that none of the geoPoints has a distance
         * @param geoPoints
         * @returns {*}
         */
        populateDistanceInGeoPoints: function(geoPoints) {
            var distance = 0,
                totalDistance = 0,
                previousPoint;

            for (var i = 0, len = geoPoints.length; i < len; i += 1) {
                if (geoPoints[i]) {
                    if (previousPoint) {
                        distance = this.calculateDistanceBetweenPointsInMeters(
                            previousPoint.latitude,
                            previousPoint.longitude,
                            geoPoints[i].latitude,
                            geoPoints[i].longitude
                        );
                        totalDistance += distance;
                        distance = totalDistance;
                    }

                    previousPoint = geoPoints[i];

                    geoPoints[i].distance = distance;
                }
            }

            return geoPoints;
        },

        sortElevationDataByDistance: function(a, b) {
            if (a.x < b.x) {
                return -1;
            }

            if (a.x > b.x) {
                return 1;
            }

            return 0;
        },

        stripDupDistancesFromPoints: function(points, distanceIndex) {
            var previousPoint,
                currentIsTheSameAsPrevious = false,
                index;

            function strip(points) {
                //strip dup distances
                for (var i = 0, len = points.length; i < len; i += 1) {
                    if (points[i]) {
                        currentIsTheSameAsPrevious = previousPoint
                            ? previousPoint[distanceIndex] === points[i][distanceIndex]
                            : false;
                        if (!currentIsTheSameAsPrevious) {
                            previousPoint = points[i];
                        } else {
                            index = i;
                            break;
                        }
                    }
                }

                if (index) {
                    points.splice(index, 1);
                    index = null;
                    strip(points);
                }
            }

            strip(points);
        },

        /**
         * This function is from Google's polyline utility.
         * @param encodedSamples - The encodedSamples attribute from GPolyline
         */

        getRandomRoundTripDirection: function() {
            return roundTripDirections[Math.floor(Math.random() * roundTripDirections.length)];
        },

        showSendToDeviceView: function(courseId, courseName, originalCoordinateSystem, sendToDeviceFrom) {
            if (this.sendToDevicePageView) {
                this.sendToDevicePageView.removeComponent();
                this.sendToDevicePageView = null;
            }
            this.sendToDevicePageView = new ReactComponentView();
            const element = document.querySelector('#sendToDevice-placeholder');
            this.sendToDevicePageView.renderComponent(NewSendToDeviceModal, element, {
                sendType: sendTypes.SEND_TO_DEVICE_TYPE_COURSE,
                courseId: courseId,
                messageName: courseName,
                courseOriginalCoordinateSystem: originalCoordinateSystem,
                sendToDeviceFrom: sendToDeviceFrom
            });
        }
    };

export default CourseUtil;
